<mat-calendar
  class="w-full block"
  (selectedChange)="_onSelectedChange($event)"
  [selected]="selectedDateRange">
</mat-calendar>
